import React, {useState, useEffect, useRef} from 'react';
import { Link, useParams } from 'react-router-dom';
import { faTv, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parse from 'html-react-parser';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import Editor from 'react-simple-wysiwyg';
import { API_URL } from '../global/components/Constants';
import { parsePhotoUtil } from '../utils/photoUtils';
import PageLoader from '../global/components/PageLoader';
import { pageInitAction } from '../utils/globalUtils';
import { 
    availabilityUtil,
    experienceLevelUtil,
    experienceLengthUtil } from '../utils/jobUtils';
import { getUserProfile} from '../utils/api-services/profile';
import DateControl from '../global/components/DateControl'; 
import Works from './components/Works';
import Educations from './components/Educations';
import Skills from './components/Skills';
import Projects from './components/Projects';
import ListDisplay from './components/ListDisplay';

function CvEdit() {

    const [cv, setCv] = useState(null);
    const [settings, setSettings] = useState([]);
    const [selectedItem, setSelectedItem] = useState("");
    const [dob, setDob] = useState({day:"", month:"", year:""});
    const [photo, setPhoto] = useState({Data:"", Selected:false});
    const [cvFile, setCvFile] = useState(null);
    const [skills, setSkills] = useState([]);
    const [works, setWorks] = useState([]);
    const [educations, setEducations] = useState([]);
    const [projects, setProjects] = useState([]);
    const [value, setValue] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [frmError, setFrmError] = useState("");
    const [loading, setLoading] = useState(false);
    const [posting, setPosting] = useState(false);

    const photoElem = useRef();
    const fileElem = useRef();

    const width = 300;
    const height = 300;

    useEffect(()=>{
        loadProfile();
    }, []);

    const loadProfile = async () => { 
        setLoading(true);
        const obj = await getUserProfile();
        if(obj?.Success){
            setCv(obj.Data);
            presetData(obj.Data);
        }
        setLoading(false);
    }
    
    function presetData(obj){

        const dob = (obj.Dob != "")? JSON.parse(obj.Dob): {day:"", month:"", year:""};
        const works = (obj.ExperienceWork != "")? JSON.parse(obj.ExperienceWork): [];
        const educations = (obj.Education != "")? JSON.parse(obj.Education): [];
        const skills = (obj.Skills != "")? JSON.parse(obj.Skills): [];
        const projects = (obj.Projects != "")? JSON.parse(obj.Projects): [];

        setDob(dob);
        setWorks(works);
        setEducations(educations);
        setSkills(skills);
        setProjects(projects);

        const data = [
            {Code: "Name", Title: "Name", Value: obj.Name, Display: obj.Name, style: styles.item.lg},
            {Code: "Email", Title: "Email", Value: obj.Email, Display: obj.Email, style: styles.item.sm},
            {Code: "Phone", Title: "Phone", Value: obj.Phone, Display: obj.Phone, style: styles.item.sm},
            {Code: "About", Title: "About", Value: obj.About, Display: obj.About, style: styles.item.sm},
            {Code: "Profession", Title: "Profession", Value: obj.Profession, Display: obj.Profession, style: styles.item.sm},
            {Code: "Dob", Title: "Date of Birth", Value: obj.Dob, Display: dob, style: styles.item.sm},
            {Code: "Location", Title: "Location", Value: obj.Location, Display: obj.Location, style: styles.item.sm},
            {Code: "Availability", Title: "Availability", Value: obj.Availability, Display: obj.Availability, style: styles.item.sm},
            {Code: "Photo", Title: "Photo", Value: obj.Photo, Display: obj.Photo, style: styles.item.sm},
            {Code: "CvFile", Title: "Upload CV", Value: obj.CvFile, Display: obj.CvFile, style: styles.item.sm},
            {Code: "ExperienceLevel", Title: "Experience Level", Value: obj.ExperienceLevel, Display: obj.ExperienceLevel, style: styles.item.sm},
            {Code: "ExperienceLength", Title: "Experience Length", Value: obj.ExperienceLength, Display: obj.ExperienceLength, style: styles.item.sm},
            {Code: "ExperienceWork", Title: "Work Experience", Value: obj.ExperienceWork, Display: works, style: styles.item.sm},
            {Code: "Education", Title: "Education & Certifications", Value: obj.Education, Display: educations, style: styles.item.sm},
            {Code: "Skills", Title: "Skills", Value: obj.Skills, Display: skills, style: styles.item.sm},
            {Code: "CoverLetter", Title: "Cover Letter", Value: obj.CoverLetter, Display: obj.CoverLetter, style: styles.item.sm},
            {Code: "Projects", Title: "Projects", Value: obj.Projects, Display: projects, style: styles.item.sm},
        ];
        setSettings(data);
    }

    const showModal = ()=>{
        clearForm();
        setModal(true);
    }

    const closeModal = ()=>{
        setModal(false);
    }

    const selectPhoto = ()=>{
        photoElem.current.click();
    }
        
    const handlePhotoChange = (event) => {
        let files = event.target.files;
        const params = {
            file: files[0],
            width: width, 
            height: height,
            setPhoto: setPhoto, 
            setMessage: setFrmError
        }
        parsePhotoUtil(params);
    }

    const handleFileChange = (event) => {
        const file = fileElem.current.files[0];
        if (!file) {
            setFrmError("Please select a file.");
            return;
        }
        setCvFile(file);
    }

    const handleDescription = (e)=>{
        setValue(e.target.value)
    }

    function editPreset(obj){
        showModal();
        setModalTitle(obj.Title);
        setSelectedItem(obj.Code);

        if(obj.Code == "Tags"){
            setTagList(obj.Value);
        }
        else{
            setValue(obj.Value);
        }
    }

    function saveForm(){
        if(selectedItem == "Dob"){
            if(dob.day == "" || dob.month == "" || dob.year == ""){
                setFrmError("Please enter date of birth");
                return;
            }
            postForm(selectedItem, JSON.stringify(dob));
        }
        else if(selectedItem == "Photo"){
            if(photo.Data == ""){
                setFrmError("Please select photo");
                return false;
            }
            postForm(selectedItem, photo.Data);
        }
        else if(selectedItem == "CvFile"){
            if(cvFile == null){
                setFrmError("Please select file");
                return false;
            }
            postCvFile();
        }
        else if(selectedItem == "ExperienceWork"){
            if(works.length == 0){
                setFrmError("Please add work experience");
                return false;
            }
            postForm(selectedItem, JSON.stringify(works));
        }
        else if(selectedItem == "Education"){
            if(educations.length == 0){
                setFrmError("Please add education");
                return false;
            }
            postForm(selectedItem, JSON.stringify(educations));
        }
        else if(selectedItem == "Skills"){
            if(skills.length == 0){
                setFrmError("Please add skill");
                return false;
            }
            postForm(selectedItem, JSON.stringify(skills));
        }
        else if(selectedItem == "Projects"){
            if(projects.length == 0){
                setFrmError("Please add project");
                return false;
            }
            postForm(selectedItem, JSON.stringify(projects));
        }
        else{
            if(value == ""){
                setFrmError("Please enter value");
                return false;
            }
            postForm(selectedItem, value);
        }
    }

    function postForm(column, value){

        setPosting(true);

        const formData = new FormData();
        formData.append('id', cv?.Id);
        formData.append('column', column);
        formData.append('value', value);

        axios({
            method: "post",
            url: API_URL + "profile/update_profile_column",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            setPosting(false)
            const obj = response.data;
            if(obj.Success){
                loadProfile();
                closeModal();
            }
        })
        .catch(function (response) {
            setPosting(false)
        });
    }

    function postCvFile(){

        setPosting(true);

        const formData = new FormData();
        formData.append('id', cv?.Id);
        formData.append('name', cv?.Name);
        formData.append('file', cvFile);

        axios({
            method: "post",
            url: API_URL + "profile/save_cv_file",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            setPosting(false)
            const obj = response.data;
            if(obj.Success){
                loadProfile();
                closeModal();
            }
        })
        .catch(function (response) {
            setPosting(false)
        });
    }

    function clearForm(){
        setValue("");
        setFrmError("");
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: 700,
            paddingTop: 50,
            paddingBottom: 100
        },
        heading:{
            wrap:{
                display: 'flex'
            },
            title:{
                color: '#999',
                marginBottom: 0,
                fontSize: 18
            },
            actions:{
                marginLeft: 'auto'
            },
            previewBtn:{
                color: '#363636',
                marginRight: 30,
                fontSize: 14,
                fontWeight: 500,
                textDecoration: 'none',
            },
        },
        item:{
            sm:{
                wrap:{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #ccc'
                },
                title:{
                    color: '#191919',
                    fontSize: 14,
                    fontWeight: 600
                },
                value: {
                    color: '#333',
                    fontSize: 13
                },
                btn:{
                    color: '#0767ce',
                    fontSize: 14,
                    textDecoration: 'none',
                },
            },
            md:{
                wrap:{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #ccc'
                },
                title:{
                    color: '#191919',
                    fontSize: 16,
                    fontWeight: 600
                },
                value: {
                    color: '#333',
                    fontSize: 16
                },
                btn:{
                    color: '#0767ce',
                    fontSize: 14,
                    textDecoration: 'none',
                },
            },
            lg:{
                wrap:{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #ccc'
                },
                title:{
                    color: '#191919',
                    fontSize: 16,
                    fontWeight: 600
                },
                value: {
                    color: '#333',
                    fontSize: 24
                },
                btn:{
                    color: '#0767ce',
                    fontSize: 14,
                    textDecoration: 'none',
                },
            },
        },
        selectBtnWrap: {
            marginBottom: 10,
        },
        selectBtn: {
            textDecoration: 'none',
            fontSize: 16,
        },
        info: {
            fontSize: 13,
        },
        frmError:{
            color: '#990000',
            fontSize: 16
        },
        photo:{
            preview:{
                width: 300,
                borderRadius: 5
            },
            img:{
                width: 300,
                borderRadius: 5
            },
            display:{
                width: 100,
                borderRadius: 5
            },
            input: {
                display: 'none'
            },
        },
        file:{
            display:{
                textDecoration: 'none'
            }
        },
        tags:{
            wrap:{
                display: 'flex',
                flexWrap: 'wrap',
                paddingTop: 10,
                paddingBottom: 10,
            },
            item:{
                marginRight: 10,
                marginBottom: 30,
                padding: '10px 20px',
                boxShadow: '0 0 3px 3px #efefef',
                borderRadius: 30
            }
        }
    }

    function settingsItem(obj){
        return (
            <div style={obj.style.wrap}>
                <div className='row'>
                    <div className='col-md-10'>
                        <h4 style={obj.style.title}>{obj.Title}</h4>
                        <div style={obj.style.value}>{settingsItemValue(obj)}</div>
                    </div>
                    <div className='col-md-2'>
                        <Link onClick={()=>editPreset(obj)} style={obj.style.btn}>Edit</Link>
                    </div>
                </div>
            </div>
        )
    }

    function settingsItemValue(obj){
        if(obj.Code == "Dob"){
            return `${obj.Display.day} ${obj.Display.month} ${obj.Display.year}`
        }
        if(obj.Code == "Photo"){
            const src = `${API_URL}uploads/profile/photo/${obj.Display}`;
            return (obj.Display!="")? 
            <img src={src} style={styles.photo.display} />: "";
        }
        if(obj.Code == "CvFile"){
            const href = `${API_URL}uploads/cv/${obj.Display}`;
            return (obj.Display!="")? 
            <a href={href} target='_blank' style={styles.file.display}>{obj.Display}</a>: "";
        }
        else if(obj.Code == "ExperienceWork"){
            return <ListDisplay type={"works"} data={obj.Display} />
        }
        else if(obj.Code == "Education"){
            return <ListDisplay type={"educations"} data={obj.Display} />
        }
        else if(obj.Code == "Skills"){
            return <ListDisplay type={"skills"} data={obj.Display} />
        }
        else if(obj.Code == "Projects"){
            return <ListDisplay type={"projects"} data={obj.Display} />
        }
        else if(obj.Code == "Description"){
            return parse(obj.Display);
        }
        else{
            return obj.Display;
        }
    }

    const nameForm = (
        <div className="form-group">
            <input type="text" value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Enter Full Name" />
        </div>
    )

    const emailForm = (
        <div className="form-group">
            <input type="text" value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Enter Email Address" />
        </div>
    )

    const phoneForm = (
        <div className="form-group">
            <input type="text" value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Enter Phone Number" />
        </div>
    )

    const aboutForm = (
        <div className='form-group'>
            <textarea value={value} onChange={e => setValue(e.target.value)} style={styles.input} rows={5} className="form-control" placeholder='Enter About Me '></textarea>
        </div>
    )

    const professionForm = (
        <div className="form-group">
            <input type="text" value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Example: Accountant" />
        </div>
    )

    const dobForm = (
        <div className="form-group">
            <DateControl date = {dob} setDate = {setDob} show = {{day:true, month:true, year: true}} />
        </div>
    )

    const locationForm = (
        <div className='form-group'>
            <input type='text' value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control" placeholder='State, Country' />
        </div>
    )

    const availabilityForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {availabilityUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const photoForm = (
        <div>
    
            {(photo.Data != "") &&
                <div style={styles.photo.preview}>
                    <img 
                        src = {photo.Selected? photo.Data: `${API_URL}/uploads/profile/photo/${photo.Data}`} 
                        style={styles.photo.img} 
                    />
                </div>
            }
    
            <div style = {styles.selectBtnWrap}>
                <Link onClick={selectPhoto} style = {styles.selectBtn}>Select Photo</Link>
            </div>
            <div style={styles.info}>{`Photo dimension should be ${width} x ${height} pixels or more`}</div>
            <input type="file" ref={photoElem} onChange={handlePhotoChange} style = {styles.photo.input} />
        </div>
    )

    const fileForm = (
        <div>
            <input type="file" ref={fileElem} onChange={handleFileChange} />
        </div>
    )

    const experienceLevelForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {experienceLevelUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const experienceLengthForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {experienceLengthUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const workExperinceForm = (
        <div className='form-group'>
            <Works params={{works: works, setWorks: setWorks}} />
        </div>
    )

    const educationForm = (
        <div className='form-group'>
            <Educations params={{educations: educations, setEducations: setEducations}} />
        </div>
    )

    const skillsForm = (
        <Skills params={{skills: skills, setSkills: setSkills}} />
    )

    const coverLetterForm = (
        <div className='form-group'>
            <Editor 
                containerProps={{ style: { minHeight: 300 } }}
                value={value}
                onChange={handleDescription}
            />
        </div>
    )

    const projectsForm = (
        <div className='form-group'>
            <Projects params={{projects: projects, setProjects: setProjects}} />
        </div>
    )

    const display = (
        <section style={styles.page}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-2'></div>
                    <div className='col-md-10'>

                        <div style = {styles.heading.wrap}>
                            <h4 style={styles.heading.title}>Edit CV</h4>
                            <div style={styles.heading.actions}>
                                <a href={`/cv/${cv?.Slug}`} className='btn' style={styles.heading.previewBtn}>
                                    <FontAwesomeIcon icon={faTv} /> &nbsp; Preview
                                </a>
                            </div>
                        </div>

                        <hr />

                        {settings.map(itm=>(
                            <div key={itm.Code}>{settingsItem(itm)}</div>
                        ))}

                        <Modal show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                            <Modal.Header>
                                <Modal.Title style={{fontSize:15}}>{modalTitle}</Modal.Title>
                                <button type="button" onClick={closeModal} className="close">&times;</button>
                            </Modal.Header>
                            <Modal.Body>  
                            
                                {selectedItem == "Name" && nameForm}
                                {selectedItem == "Email" && emailForm}
                                {selectedItem == "Phone" && phoneForm}
                                {selectedItem == "About" && aboutForm}
                                {selectedItem == "Profession" && professionForm}
                                {selectedItem == "Dob" && dobForm}
                                {selectedItem == "Location" && locationForm}
                                {selectedItem == "Availability" && availabilityForm}
                                {selectedItem == "Photo" && photoForm}
                                {selectedItem == "CvFile" && fileForm}
                                {selectedItem == "ExperienceLevel" && experienceLevelForm}
                                {selectedItem == "ExperienceLength" && experienceLengthForm}
                                {selectedItem == "ExperienceWork" && workExperinceForm}
                                {selectedItem == "Education" && educationForm}
                                {selectedItem == "Skills" && skillsForm}
                                {selectedItem == "CoverLetter" && coverLetterForm}
                                {selectedItem == "Projects" && projectsForm}

                                {frmError != "" && 
                                    <div className="form-group" style={styles.frmError}>{frmError}</div>
                                }
                            
                                <hr />

                                <div className="form-group">
                                    <Link onClick={()=>saveForm()} className='btn btn-primary'>{posting? "POSTING ...": "SAVE"}</Link>
                                </div>

                            </Modal.Body> 
                        </Modal>

                    </div>
                </div>
            </div>
        </section>
    )

    if(loading){
        return <PageLoader top={50} bottom={50} />
    }
    else{
        return display;
    }
}

export default CvEdit;